import React from 'react';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import MarketInsightService from '@app/model/market_insight/service/MarketInsightService';
import { MarketInsightQueryKeys } from '@app/model/market_insight/service/MarketInsightQueryKeys';
import { useQuery } from '@tanstack/react-query';
import Portlet from '@app/component/portlet/Portlet';
import _isEmpty from 'lodash/isEmpty';
import Utilities from '@util/Utilities';
import LosIndex from '@app/model/market_insight/LosIndex';

// marketAreaId: the market of the market tab; null = the market of the hotel.
const MarketInsightLosIndicesFragment: React.FunctionComponent<{ statDate: string, marketAreaId: number | null }> = ({ statDate, marketAreaId }) => {

	const { companyHotel } = useSelectedCompanyHotel();

	const { data: losIndices, isLoading, isSuccess } = useQuery({
		queryFn: () => MarketInsightService.findLosIndices({ companyHotelId: companyHotel.id, statDate: statDate, marketAreaId: marketAreaId }),
		queryKey: MarketInsightQueryKeys.losIndices(companyHotel.id, statDate, marketAreaId),
	});

	if (isLoading) {
		return <Portlet title="Length of Stay">
			<div className="animate-pulse flex items-center gap-x-2">
				<div className="h-2.5 bg-gray-200 rounded-full w-full mb-2.5" />
				<div className="h-2.5 bg-gray-200 rounded-full w-full mb-2.5" />
			</div>
		</Portlet>;
	}
	if (isSuccess && losIndices !== undefined && losIndices !== null && !_isEmpty(losIndices)) {

		return <Portlet title="Length of Stay">
			<div className="grid grid-cols-1 gap-x-8 sm:grid-cols-2 text-sm/6">
				{losIndices.indices.map(idx => <DisplayLosIndex key={idx.los} losIndex={idx} />)}
			</div>
		</Portlet>;
	}

	return <Portlet title="Length of Stay">
		<p className="block text-xs font-light text-gray-400">Not Available</p>
	</Portlet>;
};

const DisplayLosIndex: React.FunctionComponent<{ losIndex: LosIndex }> = ({ losIndex }) => {
	const percentage = Utilities.formatDouble(losIndex.rate * 100, 0);
	return <div className="flex justify-between items-center gap-x-2 py-1.5">
		<dt className="text-sm/6 font-medium text-gray-400">{losIndex.los}</dt>
		<dd className="flex items-center gap-x-6">
			<div className="flex items-center gap-x-1">
				<div className="overflow-hidden rounded-full w-10 bg-gray-100">
					<div className="h-2 rounded-full bg-gray-300" style={{width: `${percentage}%`}}></div>
				</div>
				<div className="font-medium text-gray-900">{percentage}%</div>
			</div>
		</dd>
	</div>;
};

export default MarketInsightLosIndicesFragment;